import { Link } from 'react-router-dom';
import Skeleton from 'react-loading-skeleton';
import { Mail, Phone, CalendarDays, ShoppingBag, Star, ChefHat, Bell } from 'lucide-react';

const fmtDate = (v) => {
  if (!v) return null;
  const d = new Date(v);
  if (Number.isNaN(d.getTime())) return null;
  return d.toLocaleDateString('en-US', { day: 'numeric', month: 'long', year: 'numeric' });
};

function InfoRow({ icon, label, value, loading }) {
  return (
    <div className="prof-info-row">
      <div className="prof-info-icon">{icon}</div>
      <div style={{ minWidth: 0 }}>
        <span style={{ fontSize: 11, fontWeight: 700, color: '#9ca3af', textTransform: 'uppercase', letterSpacing: 0.5, display: 'block', marginBottom: 2 }}>
          {label}
        </span>
        {loading
          ? <Skeleton height={15} width={160} />
          : <span style={{ fontSize: 14, fontWeight: 500, color: '#111827', fontFamily: "'Inter', sans-serif", wordBreak: 'break-all' }}>{value || '—'}</span>
        }
      </div>
    </div>
  );
}

const NAV_CARDS = [
  { to: '/my-orders', icon: ShoppingBag, color: '#0d6efd', bg: '#eff6ff', title: 'My Orders', desc: 'Track your food orders' },
  { to: '/my-wishes', icon: Star, color: '#f59e0b', bg: '#fef9ef', title: 'My Wishes', desc: 'Custom food requests' },
  { to: '/all-kitchens', icon: ChefHat, color: '#059669', bg: '#f0fdf4', title: 'Browse Kitchens', desc: 'Find local home cooks' },
  { to: '/notifications', icon: Bell, color: '#a855f7', bg: '#fdf4ff', title: 'Notifications', desc: 'Updates & alerts' },
];

export default function OverviewTab({ user, loading }) {
  const phone = user?.phone?.startsWith('+880')
    ? user.phone.replace('+880', '0')
    : user?.phone;

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 20 }}>
      <div className="prof-card">
        <p className="prof-card-label">Contact Info</p>

        <InfoRow icon={<Mail size={15} />} label="Email" value={user?.email} loading={loading} />
        <InfoRow icon={<Phone size={15} />} label="Phone" value={phone} loading={loading} />
        <InfoRow icon={<CalendarDays size={15} />} label="Joined" value={fmtDate(user?.createdAt)} loading={loading} />
      </div>

      <div className="prof-grid">
        {NAV_CARDS.map((card) => {
          const Icon = card.icon;
          return (
            <Link key={card.to} to={card.to} style={{ textDecoration: 'none' }}>
              <div
                className="prof-card"
                style={{ display: 'flex', alignItems: 'center', gap: 14, cursor: 'pointer', transition: 'box-shadow 0.15s' }}
                onMouseEnter={(e) => { e.currentTarget.style.boxShadow = '0 4px 16px rgba(0,0,0,0.08)'; }}
                onMouseLeave={(e) => { e.currentTarget.style.boxShadow = 'none'; }}
              >
                <div style={{ width: 44, height: 44, borderRadius: 12, background: card.bg, display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                  <Icon size={20} color={card.color} />
                </div>
                <div>
                  <p style={{ margin: 0, fontWeight: 700, fontSize: 14, color: '#111827', fontFamily: "'Inter', sans-serif" }}>{card.title}</p>
                  <p style={{ margin: 0, fontSize: 12, color: '#9ca3af', fontFamily: "'Inter', sans-serif" }}>{card.desc}</p>
                </div>
              </div>
            </Link>
          );
        })}
      </div>
    </div>
  );
}
